import {OnboardingRepository} from './repository/OnboardingRepository';
import {Route} from './repository/Route';
import {FileUpload} from './classes/FileUpload';
import store from './state/store/Store';
import {CROPPED_PICTURE} from './state/actions/FileUploadActions';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import PhotoSwipe from 'photoswipe';
import EventsdonConference from './modules/eventsdonConference';
import Conference from './modules/conference';
import Scanner from './classes/Scanner';
import Organisation from './modules/Organisation';

$(function() {
    EventsdonConference.init();
    Conference.init();
    Scanner.init();
    Organisation.init();

    Array.prototype.last = function() {
        return this[this.length - 1];
    };

    if (!Array.prototype.remove) {
        Array.prototype.remove = function(val) {
            var i = this.indexOf(val);
            i > -1 ? this.splice(i, 1) : [];
        };
    }

    const lightbox = new PhotoSwipeLightbox({
        gallery: '.lightbox-image',
        pswpModule: () => PhotoSwipe,
    });
    lightbox.init();

    if($('.data-table').length > 0){
        $('.data-table').each(function() {
            let $this = $(this);
            let printTitle = $this.data('print-title') || 'Conference Reports';
            let printSubtitle = $this.data('print-subtitle') || 'Reports for Conference';

            $this.DataTable({
                dom: '<"wrapper"<"datatable-button-group"B>lf><t>ip',
                initComplete: function() {
                    $('.dataTables_paginate .active a').addClass('btn-dark bg-gradient-dark fw-bolder');
                    if ($this.data('column-filter') === true) {
                        $('.gtp-dt-filter-row').remove();
                        let theadSecondRow = '<tr class="gtp-dt-filter-row bg-gradient-dark">';
                        $this.find('thead tr th').each(function(index) {
                            theadSecondRow += '<td class="gtp-dt-select-filter-' + index + '"></td>';
                        });
                        theadSecondRow += '</tr>';
                        $(theadSecondRow).insertAfter($this.find('thead tr'));

                        let filterableColumns = $this.data('filterable-columns') || 'all';
                        if (filterableColumns !== 'all') {
                            filterableColumns = [filterableColumns];
                        }

                        this.api().columns(filterableColumns).every(function(index) {
                            let column = this;
                            let select = $('td.gtp-dt-select-filter-' + index).html('<select class="form-control form-control-sm"><option value="">- Unfiltered -</option></select>');

                            select.find('select').on('change', function() {
                                let val = $.fn.dataTable.util.escapeRegex($(this).val());
                                column.search(val ? '^' + val + '$' : '', true, false).draw();
                            });

                            column.data().unique().sort().each(function(d, j) {
                                select.find('select').append('<option value="' + $(d).html() + '">' + $(d).html() + '</option>');
                            });

                            new Choices($('td.gtp-dt-select-filter-' + index + ' select')[0], {
                                allowHTML: true,
                                itemSelectText: '',
                            });
                        });
                    }

                    this.api().on('column-visibility.dt', function(e, settings, column, state) {
                        let filterTd = $(`.gtp-dt-select-filter-${column}`);
                        if (state) {
                            filterTd.show();
                        } else {
                            filterTd.hide();
                        }
                    });
                },
                drawCallback: function() {
                    $('.dataTables_paginate .active a').addClass('btn-dark bg-gradient-dark fw-bolder');
                },
                buttons: [
                    {
                        extend: 'copyHtml5',
                        init: initButton,
                        exportOptions: {
                            columns: ':visible'
                        }
                    },
                    {
                        extend: 'excelHtml5',
                        init: initButton,
                        exportOptions: {
                            columns: ':visible'
                        }
                    },
                    {
                        extend: 'csvHtml5',
                        init: initButton,
                        exportOptions: {
                            columns: ':visible'
                        }
                    },
                    {
                        extend: 'pdfHtml5',
                        init: initButton,
                        title: '',
                        customize: function (doc) {
                            doc.content.splice(0, 0, {
                                text: printTitle,
                                alignment: 'center',
                                fontSize: 18,
                                bold: true
                            });
                            doc.content.splice(1, 0, {
                                text: printSubtitle,
                                alignment: 'center',
                                fontSize: 10
                            });
                        },
                        exportOptions: {
                            columns: ':visible'
                        }
                    },
                    {
                        extend: 'print',
                        init: initButton,
                        title: '',
                        customize: function (win) {
                            $(win.document.body)
                            .css('font-size', '10pt')
                            .prepend(
                                '<h3 style="text-align: center;">'+ printTitle +'</h3>' +
                                '<p style="text-align: center;">'+ printSubtitle +'</p>'
                            );

                            $(win.document.body).find('table')
                            .addClass('display')
                            .css('font-size', 'inherit');
                        },
                        exportOptions: {
                            columns: ':visible'
                        }
                    },
                    'colvis'
                ],
                pageLength: 50,
                language: {
                    paginate: {
                        previous: '<span class="las la-chevron-left"></span>',
                        next: '<span class="las la-chevron-right"></span>',
                    },
                    aria: {
                        paginate: {
                            previous: 'Previous',
                            next: 'Next',
                        },
                    },
                },
            });
            // $this.columns().every(function(index) {
            //     let isVisible = this.visible();
            //     $(`.gtp-dt-select-filter-${index}`).toggle(isVisible);
            // });
        });
    }

    function initButton(dt, node, config) {
        let allowedExportColumns = getExportColumnsFromTable(dt);
        config.exportOptions = {
            columns: allowedExportColumns
        };
    }
    function getExportColumnsFromTable(table) {
        let exportColumns = $(table.table().node()).data('export-columns');
        if (exportColumns == undefined || exportColumns === '' || exportColumns === 'all') {
            return '';
        } else {
            return [exportColumns];
        }
    }


    $(document).on('click', '.form-submit', function(e) {
        e.preventDefault();
        let form = $(this).closest('.needs-validation');
        if (form.validateMe()) {
            if (form.data('route') !== '') {
                new Route(form.data('route')).dispatch();
            } else {
                form.trigger('submit');
            }
        }
    });

    if($('#wizard').length > 0){
        $('#wizard').steps({
            headerTag: 'h4',
            bodyTag: 'section',
            transitionEffect: 'slide',
            // enableAllSteps: true,
            onInit: function() {
                $('.actions li a').addClass('btn text-white bg-gradient-info btn-capitalize');
                $('.actions li:first-child a').removeClass('bg-gradient-info').addClass('btn bg-gradient-dark');
            },
            onStepChanging: function(event, currentIndex, newIndex) {
                let form = $(this).find('.needs-validation#form-step-' + currentIndex);
                if (form.validateMe()) {
                    if (newIndex === 1) {
                        $('.wizard > .steps ul').addClass('step-2');
                    } else {
                        $('.wizard > .steps ul').removeClass('step-2');
                    }
                    if (newIndex === 2) {
                        $('.wizard > .steps ul').addClass('step-3');
                    } else {
                        $('.wizard > .steps ul').removeClass('step-3');
                    }
                    return true;
                } else {
                    return false;
                }
            },
            onFinishing: function(event, currentIndex) {
                new OnboardingRepository().activate();
            },
            labels: {
                finish: 'Activate',
                next: 'Continue',
                previous: 'Back',
            },
        });
        // Custom Button Jquery Steps
        $('.forward').click(function() {
            $('#wizard').steps('next');
        });
        $('.backward').click(function() {
            $('#wizard').steps('previous');
        });
    }


    $(document).on('click', '.file-input-btn', function() {
        let target = $('#' + $(this).data('target'));
        let uploadType = $(this).data('upload-type');
        let name = target.attr('name');
        let id = target.attr('id');
        // refreshFileInput(target, $('.' + uploadType + '-buttons-container'), name, id, uploadType);
        target.trigger('click');
    });

    function refreshFileInput(fileInputToRefresh, insertAfterThisElement, name, id, uploadType)
    {
        fileInputToRefresh.remove();
        insertAfterThisElement.after('<input class="file-input" name="' + name + '" id="' + id + '" data-upload-type="' + uploadType + '" type="file" accept="image/png, image/jpeg, image/webp">');
    }

    let cropperData = null;
    let croppedData = null;
    $(document).on('change', '#picture-upload', function() {
        cropperData = new FileUpload($(this)).onChange();
    });

    $(document).on('click', '.reset-crop', function() {
        new FileUpload().onResetCrop(cropperData.cropper);
    });

    $(document).on('click', '.crop', function() {
        croppedData = new FileUpload().onCrop(cropperData);
        store.dispatch(CROPPED_PICTURE(croppedData));
    });

    $(document).on('click', '.btn-import-delegates', function() {
        let importFileInput = Dropzone.forElement('#delegates-import-file');
        importFileInput.processQueue();
    });

    $(document).on('click', '.btn-import-branches', function() {
        let importFileInput = Dropzone.forElement('#branches-import-file');
        importFileInput.processQueue();
    });

    $(document).on('click', '.btn-upload-conference-docs', function() {
        let importFileInput = Dropzone.forElement('#conference-docs-upload-file');
        importFileInput.processQueue();
    });



    if($('.modal').length > 0){
        const modal = document.querySelector('.modal')
        modal.addEventListener('shown.bs.modal', event => {
            // Churchpal.initChoices();
        })
    }
});


